import React from 'react';
import cx from 'classnames';

export enum PageSectionTheme {
    NONE = 'NONE',
    ONE = 'ONE',
    TWO = 'TWO',
    THREE = 'THREE',
    FOUR = 'FOUR',
    FIVE = 'FIVE',
}

const mapThemeToClasses = {
    [PageSectionTheme.NONE]: '',
    [PageSectionTheme.ONE]: 'page__section--one',
    [PageSectionTheme.TWO]: 'page__section--two',
    [PageSectionTheme.THREE]: 'page__section--three',
    [PageSectionTheme.FOUR]: 'page__section--four',
    [PageSectionTheme.FIVE]: 'page__section--five',
};

type Props = {
    children?: React.ReactNode;
    extraClass?: string;
    jsClass?: string;
    isFullWidth?: boolean;
    noTopPadding?: boolean;
    noBottomPadding?: boolean;
    theme?: PageSectionTheme;
    hasPaddingEqual?: boolean;
    noVerticalPadding?: boolean;
    noHorizontalPadding?: boolean;
    hasNoPadding?: boolean;
    backgroundColor?: string;
    inner?: boolean;
    tag?: 'div' | 'section';
};

function PageSection(props: Props) {
    const {
        children,
        theme = PageSectionTheme.NONE,
        hasPaddingEqual,
        hasNoPadding,
        extraClass,
        jsClass,
        noTopPadding,
        noBottomPadding,
        noVerticalPadding,
        noHorizontalPadding,
        backgroundColor,
        inner = true,
        tag = 'div',
    } = props;

    const className = cx({
        page__section: true,
        [mapThemeToClasses[theme]]: true,
        [extraClass as string]: extraClass,
        [jsClass as string]: jsClass,
        'page__section--padding-equal': hasPaddingEqual,
        'page__section--no-top-padding': noTopPadding,
        'page__section--no-bottom-padding': noBottomPadding,
        'page__section--no-vertical-padding': noVerticalPadding,
        'page__section--no-horizontal-padding': noHorizontalPadding,
        'page__section--no-padding ': hasNoPadding,
    });

    const Tag = tag;

    return (
        <Tag className={className} style={{ backgroundColor }}>
            {inner ? <div className="page__section-inner">{children}</div> : children}
        </Tag>
    );
}

PageSection.Theme = PageSectionTheme;

export default PageSection;
